/** フォーカス可能な要素のセレクタリスト */
var e=["input:not([disabled]):not([type=hidden])","select:not([disabled])","textarea:not([disabled])","button:not([disabled])","a[href]","area[href]","summary","iframe","object","embed","audio[controls]","video[controls]","[contenteditable]"],t=t=>{e.push('[tabindex]:not([tabindex="-1"]):not([disabled])');var n=e.join(':not([hidden]):not([tabindex="-1"]),');return t.querySelectorAll(n)},n=e=>{var n=t(e);0!==n.length&&n[0].focus()},o=(e,n)=>{if("Tab"===e.key){var o=t(n);if(0!==o.length){var a=document.activeElement,d=o[0],i=o[o.length-1];
// 最初の要素でシフト+Tabを押した時は一番下のタブ可能要素にフォーカス
return e.shiftKey&&a===d?(e.preventDefault(),void i.focus()):
// 最後の要素でTabを押した時は最初のタブ可能な要素にフォーカス
e.shiftKey||a!==i?void 0:(e.preventDefault(),void d.focus())}}};
/**
 * 引数で渡された要素配下のフォーカスを当てられる要素を全件取得する
 *
 * @param targetElement
 */export{t as findTabbableElements,n as focusFirstTabbableElementInModalBody,o as moveFocusingElementWithLoop};
